import React, { useState } from "react";
import { BackgroundImage, Faq } from "../../ThirdComponents";
import { serviceFaqs } from "../../thirdUtils/constant";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

const ThirdFaq = (props) => {
    const [leftActiveIndex, setLeftActiveIndex] = useState(serviceFaqs.length - 1);
    const [rightActiveIndex, setRightActiveIndex] = useState(serviceFaqs.length - 1);
    const { selectedLanguage, language } = props;
    const isELSelect = language?.language === 'english';
    const isAlSelect = language?.language === 'arabic';

    const toggleLeftActiveIndex = (index) => {
        setLeftActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    const toggleRightActiveIndex = (index) => {
        setRightActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    return (
        <div>
            <BackgroundImage {...props} heading={selectedLanguage?.txt_faq} mainClass='third-design-faq-banner' />
            <Faq {...props} secondClass='third-design-faq-screen-container' />
            <div className={`third-design-faq-container third-design-faq-screen-container`}>
                <div className="third-design-service-faqs-left-div">
                    <h1 className="third-design-heading-2">{selectedLanguage?.txt_payment_question}</h1>
                    <p className="third-design-heading-text">
                        {selectedLanguage?.txt_it_is_important_to_take_care}
                    </p>
                    <div className="third-design-service-faqs-container">
                        {serviceFaqs.map((v, i) => (
                            <div key={i} className="third-design-service-faqs-div">
                                <div className={leftActiveIndex === i ? "third-design-service-faqs-question-div third-design-service-faqs-active-question-div" : "third-design-service-faqs-question-div"} onClick={() => toggleLeftActiveIndex(i)}>
                                    <div>
                                        <h2 className="third-design-service-faqs-question">
                                            {isELSelect ? v?.question : (isAlSelect ? v?.alQuestion : v?.glQuestion)}
                                        </h2>
                                        <button>
                                            {leftActiveIndex === i ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                        </button>
                                    </div>
                                </div>
                                {leftActiveIndex === i ? <p className="service-faq-answer">
                                    {isELSelect ? v?.answer : (isAlSelect ? v?.alAnswer : v?.glAnswer)}
                                </p> : null}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="third-design-service-faqs-left-div third-design-faqs-right-div">
                    <h1 className="third-design-heading-2">{selectedLanguage?.txt_appointment_question}</h1>
                    <p className="third-design-heading-text">
                        {selectedLanguage?.txt_it_is_important_to_take_care}
                    </p>
                    <div className="third-design-service-faqs-container">
                        {serviceFaqs.map((v, i) => (
                            <div key={i} className="third-design-service-faqs-div">
                                <div className={rightActiveIndex === i ? "third-design-service-faqs-question-div third-design-service-faqs-active-question-div" : "third-design-service-faqs-question-div"} onClick={() => toggleRightActiveIndex(i)}>
                                    <div>
                                        <h2 className="third-design-service-faqs-question">
                                            {isELSelect ? v?.question : (isAlSelect ? v?.alQuestion : v?.glQuestion)}
                                        </h2>
                                        <button>
                                            {rightActiveIndex === i ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                        </button>
                                    </div>
                                </div>
                                {rightActiveIndex === i ? <p className="service-faq-answer">
                                    {isELSelect ? v?.answer : (isAlSelect ? v?.alAnswer : v?.glAnswer)}
                                </p> : null}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ThirdFaq;
